import { Component } from '@angular/core';
import { RangeWidget as _RangeWidget } from '../angular2-schema-form-shim';
import { JSONSchema } from '../types/json-schema';
import { isWidgetRequired } from './overrides';

@Component( {
  selector: 'sp-range-widget',
  templateUrl: './range.widget.html',
} )
export class RangeWidget extends _RangeWidget {
  schema: JSONSchema;

  get required() {
    return isWidgetRequired( this );
  }
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/range.widget.ts